import React from 'react';
import { observer } from 'mobx-react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import UnrealisedGainsSummaryLookup from '../Models/Lookups/UnrealisedGainsSummaryLookup';
import UnrealisedGainsSummaryVM from './UnrealisedGainsSummaryVM';

interface IUnrealisedGainsSummaryProps {
    viewModel: UnrealisedGainsSummaryVM;
}

@observer
export default class UnrealisedGainsSummary extends React.Component<IUnrealisedGainsSummaryProps> {

    constructor(props: IUnrealisedGainsSummaryProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
          <>
          <Neo.Card>
            {viewModel.unrealisedGainsSummaryPageManager.totalRecords > 0 &&               
                <div className="inner-container">
                  <Neo.Pager
                    pageManager={viewModel.unrealisedGainsSummaryPageManager}
                    pageControlProps={{ pageSizeLabel: "Show" }}
                  >
                    <div className="horizontalScroll inner-container">
                      <NeoGrid.Grid<UnrealisedGainsSummaryLookup> className={"table-striped"}>
                        {(item, meta) => (
                          <NeoGrid.RowGroup>
                            <NeoGrid.Row>
                              <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                              <NeoGrid.Column display={meta.instrument}   label={TextConstants.Labels.Instrument} />
                              <NeoGrid.Column display={meta.instrumentCode} label={TextConstants.Labels.InstrumentCode} />
                              <NeoGrid.Column display={meta.isinCode} label={TextConstants.Labels.Isin} />
                              <NeoGrid.Column display={meta.totalGrossNC} label={TextConstants.Labels.TotalGrossNC} />
                              <NeoGrid.Column display={meta.portfolioBookPriceNC} label={TextConstants.Labels.PortfolioBookPriceNC} />
                              <NeoGrid.Column display={meta.unrealisedGainNC} label={TextConstants.Labels.UnrealisedGainOrLoss} />
                            </NeoGrid.Row>
                          </NeoGrid.RowGroup>
                        )}
                      </NeoGrid.Grid>
                    </div>
                  </Neo.Pager>
                </div>
              }
                {viewModel.unrealisedGainsSummaryPageManager.totalRecords <= 0 && (
                  <div className="col-md-12 p-0 text-center">
                    {TextConstants.GeneralText.NoRecords}
                  </div>
                )}
              </Neo.Card>
           
          </>
        );
    }
}